import CommercialLayout from "../../../components/CommercialLayout";
import { useStores } from "../../../context/storesContext";
import {
  BigQueryComparative,
  TurnoverObjective,
} from "../../../types/commercial";
import CommercialContentPage from "../../../components/CommercialContentPage";
import useSWR from "swr";
import { Range } from "../../../utils/range";
import { fetcherWithStoreKey } from "../../../utils/fetcher";
import { EcomServiceType } from "../../../utils/ecomServiceType";
import { useKpiVisibility } from "../../../kpis/useKpiVisibility";
import useBreakPoint from "../../../utils/useBreakPoint";
import CommercialContentPageDesktop from "../../../components/CommercialContentPageDesktop";
import { isEmailInWhitelist } from "../../../utils/whiteListUtils";
import { useAuth } from "../../../Auth/AuthProvider";
import useLandscape from "../../../utils/useLandscape";

function Yesterday() {
  const { user } = useAuth();
  const { selectedStore } = useStores();
  const { isKpiExists } = useKpiVisibility();

  const currentView = useBreakPoint();
  const isLandscape = useLandscape();
  const isDesktopOrTablet =
    currentView === "desktop" ||
    currentView === "tablet" ||
    (currentView === "phone" && isLandscape);
  const displayLegacyUi = !isEmailInWhitelist("ECOMMERCE_NEW_IHM_WHITE_LIST", user) || !isDesktopOrTablet;

  // Yesterday turnover
  const { data: yesterdayTurnoverData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "Turnover")
        ? [
            `/commercial/turnover?range=${Range.PreviousDay}`,
            selectedStore?.storeKey as string, selectedStore.countryKey as string
          ]
        : null,
    ([url, storeEan, countryKey]) =>
      fetcherWithStoreKey(url,  storeEan as string, countryKey as string)
  );

    // Yesterday promo turnover
  const { data: yesterdayTurnoverPromoData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "TurnoverPromo")
        ? [
            `/commercial/turnoverPromo?range=${Range.PreviousDay}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeKey]) =>
      fetcherWithStoreKey(url,  storeKey as string)
  );

      // Yesterday member card turnover
  const { data: yesterdayMemberCardTurnoverData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "MemberCardTurnover")
        ? [
            `/commercial/memberCardTurnover?range=${Range.PreviousDay}&chain=${"SDV"}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeKey]) =>
      fetcherWithStoreKey(url,  storeKey as string)
  );


    // Yesterday promo turnover
  const { data: yesterdayPastTurnoverPromoData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "TurnoverPromo")
        ? [
            `/commercial/turnoverPromo?range=${Range.PreviousDayLastYear}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeKey]) =>
      fetcherWithStoreKey(url,  storeKey as string)
  );

      // Yesterday member card turnover
  const { data: yesterdayPastMemberCardTurnoverData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "MemberCardTurnover")
        ? [
            `/commercial/memberCardTurnover?range=${Range.PreviousDayLastYear}&chain=${"SDV"}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeKey]) =>
      fetcherWithStoreKey(url,  storeKey as string)
  );

  // past week turnover
  const { data: yesterdayPastTurnoverData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "Turnover")
        ? [
            `/commercial/turnover?range=${Range.PreviousDayLastYear}`,
            selectedStore?.storeKey as string, selectedStore.countryKey as string
          ]
        : null,
    ([url, storeEan, countryKey]) =>
      fetcherWithStoreKey(url,  storeEan as string, countryKey as string)
  );
  //objective
  const { data: yesterdayObjectiveTurnoverData } = useSWR<TurnoverObjective>(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "Turnover")
        ? [
            `/commercial/objective?range=${Range.PreviousDay}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );
  // current Drive turnover
  const { data: previousdayDriveTurnoverData } = useSWR(
    () =>
      selectedStore?.storeKey
        ? [
            `/drive/turnover?range=${Range.PreviousDay}&ecomServiceType=${EcomServiceType.EcomTotal}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );
  // past Drive turnover
  const { data: pastDriveTurnoverData } = useSWR(
    () =>
      selectedStore?.storeKey
        ? [
            `/drive/turnover?range=${Range.PreviousDayLastYear}&ecomServiceType=${EcomServiceType.EcomTotal}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );
  //Comparative
  const { data: yesterdayComparativeData, error: yesterdayComparativeError } =
    useSWR<Array<BigQueryComparative>>(
      () =>
        selectedStore?.storeKey && isKpiExists("Commercial", "Comparative")
          ? [
              `/commercial/comparative?range=${
                Range.PreviousDay
              }&storeType=${selectedStore?.storeType?.toUpperCase()}`,
              selectedStore?.storeKey as string,
            ]
          : null,
      ([url, storeEan]) =>
        fetcherWithStoreKey(url,  storeEan as string)
    );
  // previousday sector turnover
  const { data: previousdaySectorData, error: previousdaySectorError } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "TurnoverBySector") && displayLegacyUi
        ? [
            `/commercial/sector?range=${
              Range.PreviousDay
            }&storeType=${selectedStore?.storeType.toUpperCase()}&sector=${"SDV"}`,
            selectedStore?.storeKey as string, selectedStore.countryKey as string
          ]
        : null,
    ([url, storeEan, countryKey]) =>
      fetcherWithStoreKey(url,  storeEan as string, countryKey as string)
  );
  // Objective DRIVE
  const { data: currentDriveObjectiveData } = useSWR(
    () =>
      selectedStore?.storeKey
        ? [
            `/drive/objective?range=${Range.PreviousDay}&ecomServiceType=${EcomServiceType.Drive}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );
    // tryptich turnover
    const { data: currentTurnoverTriptychData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "TurnoverTriptych")
        ? [
            `/commercial/turnoverTriptych/allBrands?range=${Range.PreviousDay}`,
            
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );

    const { data: pastTurnoverTriptychData } = useSWR(
    () =>
      selectedStore?.storeKey && isKpiExists("Commercial", "TurnoverTriptych")
        ? [
            `/commercial/turnoverTriptych/allBrands?range=${Range.PreviousDayLastYear}`,
            
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );

  const contentPageProps = {
    hasTurnoverByHour: false,
    hasComparative: true,
    storeType: selectedStore?.storeType!,
    currentDriveData: previousdayDriveTurnoverData,
    currentTurnoverData: yesterdayTurnoverData,
    currentTurnoverPromoData: yesterdayTurnoverPromoData,
    currentMemberCardTurnoverData: yesterdayMemberCardTurnoverData,
    driveObjective: currentDriveObjectiveData,
    pastDriveData: pastDriveTurnoverData,
    pastTurnoverData: yesterdayPastTurnoverData,
    pastTurnoverPromoData: yesterdayPastTurnoverPromoData,
    pastMemberCardTurnoverData: yesterdayPastMemberCardTurnoverData,
    sectorListData: previousdaySectorData,
    turnoverObjectiveData: yesterdayObjectiveTurnoverData!,
    comparativeList: yesterdayComparativeData,
    currentTurnoverTriptychData: currentTurnoverTriptychData,
    pastTurnoverTriptychData: pastTurnoverTriptychData,
    isLoadingSector: !previousdaySectorData,
    isLoadingTurnover: false,
    isLoadingTurnoverByHour: !!previousdaySectorError || previousdaySectorData === null,
    isLoadingComparative: !yesterdayComparativeData,
    hasErrorSector: false,
    hasErrorTurnover: false,
    hasErrorTurnoverByHour: false,
    hasErrorComparative: !!yesterdayComparativeError || yesterdayComparativeData === null,
    openInformationModal: () => null,
    range: Range.PreviousDay,
  };

  return (
    <CommercialLayout>
      {displayLegacyUi ? (
        <CommercialContentPage {...contentPageProps} />
      ) : (
        <CommercialContentPageDesktop {...contentPageProps} />
      )}
    </CommercialLayout>
  );
}

export default Yesterday;
